import { useCallback, useMemo, type FC } from 'react';
import { useNavigate } from 'react-router';
import { useResource } from '@axios-use/react';
import dayjs from 'dayjs';

import type { CouponInfoItem } from '@/apis/tiktok';
import { getUserCartListWithoutLoginReqConfig } from '@/apis/tiktok';
import type { PromotionCouponsCardMenuDiscount, PromotionCouponsCardDiscountItem } from '@/apis/product/types';
import { channelNavigateTo, isDouyinAppChannel } from '@/channels';
import { LOGIN_UNIONPAY } from '@/constants/path';

import ProductMenuCouponDiscount from './index';

const getCouponsCardMenuDiscountByTiktokCoupons = (
  items?: CouponInfoItem[],
  limit?: number,
): PromotionCouponsCardMenuDiscount | undefined => {
  if (Array.isArray(items) && items.length > 0) {
    const limitedItems = limit ? items.slice(0, limit) : items;

    const discounts = limitedItems.map((item) => {
      const startTrade = item?.startTime ? dayjs(item.startTime * 1000).format('YYYY.MM.DD') : undefined;
      const endTrade = item?.expireTime ? dayjs(item.expireTime * 1000).format('YYYY.MM.DD') : undefined;

      return {
        id: item.couponCode,
        code: item.couponCode,
        title: item.productName,
        image: item.couponPreviewPath,
        timeRange: startTrade && endTrade ? `${startTrade}-${endTrade}` : undefined,
      } as PromotionCouponsCardDiscountItem;
    });

    return {
      totalCouponCount: discounts.length,
      discountItems: discounts,
    };
  }
  return undefined;
};

export const FakerProductMenuCouponDiscount: FC<{ className?: string }> = (props) => {
  const { className } = props;

  const [list] = useResource(getUserCartListWithoutLoginReqConfig, [{ page: 1, page_size: 4 }]);

  const data = useMemo(
    () => getCouponsCardMenuDiscountByTiktokCoupons(list.data?.certificates),
    [list.data?.certificates],
  );

  const navigate = useNavigate();
  const onLogin = useCallback(() => {
    if (isDouyinAppChannel()) {
      channelNavigateTo(`/pages/login/index`, {
        redirect: true,
      });
    } else {
      navigate(LOGIN_UNIONPAY);
    }
  }, [navigate]);

  if (data === undefined) return null;

  return (
    <ProductMenuCouponDiscount
      className={className}
      data={data}
      hideTotalText
      onAdd={onLogin}
      onCardClick={onLogin}
      onMore={onLogin}
    />
  );
};
